import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import {
  AppraisalTaskCreateDto,
  AppraisalTaskDto,
  AppraisalTaskUpdateDto,
  AppraisalTaskStatusUpdateDto
} from '../models';

@Injectable()
export class AppraisalTaskService {
  private readonly API_BASE = `${environment.BASE_URL_V2}/appraisal/tasks`;

  constructor(private http: HttpClient) {}

  getByMeetingId(meetingId: number): Observable<AppraisalTaskDto[]> {
    return this.http
      .get<AppraisalTaskDto[]>(`${this.API_BASE}/meeting/${meetingId}`)
      .pipe(map((result: any) => result ?? []), catchError(this.handleError));
  }

  getByAssigneeId(userId: number): Observable<AppraisalTaskDto[]> {
    return this.http
      .get<AppraisalTaskDto[]>(`${this.API_BASE}/assignee/${userId}`)
      .pipe(map((result: any) => result ?? []), catchError(this.handleError));
  }

  getById(taskId: number): Observable<AppraisalTaskDto> {
    return this.http
      .get<AppraisalTaskDto>(`${this.API_BASE}/${taskId}`)
      .pipe(catchError(this.handleError));
  }

  create(dto: AppraisalTaskCreateDto): Observable<number> {
    return this.http
      .post<{ id: number }>(this.API_BASE, dto)
      .pipe(map(result => result?.id ?? 0), catchError(this.handleError));
  }

  update(taskId: number, dto: AppraisalTaskUpdateDto): Observable<void> {
    return this.http
      .put<void>(`${this.API_BASE}/${taskId}`, dto)
      .pipe(catchError(this.handleError));
  }

  updateStatus(
    taskId: number,
    dto: AppraisalTaskStatusUpdateDto
  ): Observable<void> {
    return this.http
      .patch<void>(`${this.API_BASE}/${taskId}/status`, dto)
      .pipe(catchError(this.handleError));
  }

  delete(taskId: number): Observable<void> {
    return this.http
      .delete<void>(`${this.API_BASE}/${taskId}`)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    const message =
      error.error?.message ||
      (error.status >= 500
        ? 'A server error occurred. Please try again later.'
        : `Request failed with status ${error.status}`);
    return throwError(() => new Error(message));
  }
}
